export const HEADER_HEIGHT = 25
export const PIN_HEIGHT = 50;
export const NODE_WIDTH = 200;
